/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Rename_SuccessInputs */

const en_dialog_rename_success = /** @type {(inputs: Dialog_Rename_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update title successful`)
};

const es_dialog_rename_success = /** @type {(inputs: Dialog_Rename_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título actualizado exitosamente`)
};

/**
* | output |
* | --- |
* | "Update title successful" |
*
* @param {Dialog_Rename_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_rename_success = /** @type {((inputs?: Dialog_Rename_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Rename_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_rename_success(inputs)
	return en_dialog_rename_success(inputs)
});